<template>
  <div>
    <p>{{ formattedString }}</p>
    <span>
      <a
        :href="link"
        v-if="!isReadMore"
        @click="triggerReadMore($event, true)"
        >{{ moreStr }}</a
      >
      <a
        :href="link"
        v-if="isReadMore"
        @click="triggerReadMore($event, false)"
        >{{ lessStr }}</a
      >
    </span>
  </div>
</template>

<script>
export default {
  name: "read-more",
  props: {
    moreStr: {
      type: String,
      default: "read more",
    },
    lessStr: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: "#",
    },
    maxChars: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      isReadMore: false,
    };
  },
  computed: {
    formattedString() {
      // Strip HTML to plain text before truncating to avoid splitting tags
      const div = document.createElement('div');
      div.innerHTML = this.text;
      const plainText = div.textContent || div.innerText || '';
      if (!this.isReadMore && plainText.length > this.maxChars) {
        return plainText.substring(0, this.maxChars) + '...';
      }
      return plainText;
    },
  },
  methods: {
    triggerReadMore(e, b) {
      if (this.link == "#") {
        e.preventDefault();
      }
      this.isReadMore = b;
    },
  },
};
</script>
